<ion-item [formGroup]="parent">
  <ion-toggle
    [id]="question.key"
    [formControlName]="question.key"
    [attr.disabled]="question.disabled || question.readonly"
    [checked]="question.value"
  >
  </ion-toggle>
</ion-item>
